import $ from 'jquery';

export default {
    data() {
        return {
            animDelta: 200
        };
    },
    methods: {
        beforeEnter: function (el) {
            $(el).removeClass('show');
            $(el).addClass('hidden');
        },
        enter: function (el, done) {
            var delay = ((el.dataset.index) * this.animDelta);
            setTimeout(() => {
                $(el).addClass('show');
            }, delay);

        },

    },
    mounted() {


    }
};